import React, { useMemo } from 'react';

import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

import MauveProfileIcon from '../../../images/testimonials/profile_mauve.svg';

interface TestimonialCardProps {
  className?: string;
  type: 'Lab' | 'Operations' | 'Clinic';
  quote: string;
  name: string;
  position: string;
  img?: IGatsbyImageData;
}

const TestimonialCard = (props: TestimonialCardProps) => {
  const containerClassName = props.className
    ? `${classNames.container} ${props.className}`
    : classNames.container;

  const typeColorClassName = useMemo(
    () =>
      props.type === 'Lab'
        ? 'tw-bg-mauve'
        : props.type === 'Clinic'
        ? 'tw-bg-algae'
        : 'tw-bg-periwinkle-200',
    [props.type],
  );

  return (
    <div className={containerClassName}>
      <h3 className={classNames.quote}>{props.quote}</h3>
      <div className={classNames.personContainer}>
        <div className={classNames.image}>
          {props.img ? (
            <GatsbyImage image={props.img} alt="Profile image" />
          ) : (
            <img src={MauveProfileIcon} alt="Profile icon" />
          )}
        </div>
        <div className={classNames.personInfoContainer}>
          <h4 className={classNames.name}>{props.name}</h4>
          <p className={classNames.position}>{props.position}</p>
        </div>
      </div>
      <div className={`${classNames.type} ${typeColorClassName}`}>
        {props.type}
      </div>
    </div>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-flex-col',
    'tw-py-[40px]',
    'tw-px-[32px]',
    'xl:tw-px-[40px]',
    'tw-bg-white',
    'tw-rounded-[8px]',
    'tw-text-start',
  ].join(' '),
  quote: ['tw-h3'].join(' '),
  personContainer: [
    'tw-flex',
    'tw-flex-col',
    'tw-mt-[24px]',
    'md:tw-mt-[40px]',
    'tw-items-start',
    'xl:tw-items-center',
    'tw-justify-start',
    'xl:tw-flex-row',
    'tw-gap-[16px]',
  ].join(' '),
  image: ['tw-flex', 'tw-w-[60px]', 'tw-h-[60px]'].join(' '),
  personInfoContainer: ['tw-flex', 'tw-flex-col', 'tw-gap-[8px]'].join(' '),
  name: ['tw-body1-emphasis'].join(' '),
  position: ['tw-caption2 tw-text-grey-800'].join(' '),
  type: [
    'tw-flex',
    'tw-w-fit',
    'tw-subtitle',
    'tw-text-white',
    'tw-mt-[24px]',
    'tw-px-[14px]',
    'tw-py-[6px]',
    'tw-rounded-[18px]',
  ].join(' '),
};

export { TestimonialCard };
